var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiamond = function SvgDiamond(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7187 3.35522H6.28118C6.0175 3.3625 5.75922 3.43207 5.52722 3.55828C5.29523 3.68448 5.09605 3.86382 4.94576 4.08175L2.08639 8.06187C1.87407 8.3635 1.76803 8.72778 1.78511 9.09688C1.80218 9.466 1.9414 9.8188 2.18065 10.0993L10.7588 20.0338C10.9056 20.2241 11.0938 20.378 11.3089 20.4839C11.524 20.5899 11.7604 20.6449 11.9999 20.6449C12.2395 20.6449 12.4758 20.5899 12.6909 20.4839C12.9061 20.378 13.0942 20.2241 13.2411 20.0338L21.8192 10.0993C22.0584 9.8188 22.1977 9.466 22.2148 9.09688C22.2318 8.72778 22.1258 8.3635 21.9135 8.06187L19.0541 4.08175C18.9038 3.86382 18.7047 3.68448 18.4727 3.55828C18.2407 3.43207 17.9823 3.3625 17.7187 3.35522Z",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1827 3.35522L7.34753 9.33463L12 20.6449",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8645 3.35522L16.6839 9.33463L12 20.6449",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81482 9.34363H22.1851",
    stroke: "currentColor",
    strokeWidth: 1.995,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiamond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "diamond.417e7cbbfa0d5a363985f32b247430bc.svg";